<mat-form-field class="bold-required-field">
  <mat-label>
    {{ fieldLabel }}
  </mat-label>
  @if (isUppercase) { @if (isStripSpaces) {
  <input
    matInput
    controlValueToUpperCase
    controlValueStripSpaces
    type="inputType"
    [readonly]="isReadOnly"
    [formControl]="textFieldControl"
    [attr.test-id]="testId"
  />
  } @else {
  <input
    matInput
    controlValueToUpperCase
    type="inputType"
    [readonly]="isReadOnly"
    [formControl]="textFieldControl"
    [attr.test-id]="testId"
  />
  } } @else if (isLoadNumberField) {
  <input
    matInput
    appLoadNumberInput
    type="inputType"
    [readonly]="isReadOnly"
    [formControl]="textFieldControl"
    [attr.test-id]="testId"
  />
  } @else {
  <input matInput type="inputType" [readonly]="isReadOnly" [formControl]="textFieldControl" />
  } @if (hintText) {
  <mat-hint class="info-text">{{ hintText | translate }}</mat-hint>
  }
  <mat-error>
    <ng-content></ng-content>
  </mat-error>
</mat-form-field>
